import '../../IconButton.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import "../../Utilities.js";
import { DefaultButton, IconButton as IconButton$2 } from "@fluentui/react/lib/Button";
import { WithCallout } from "../Callout/WithCallout.js";
import { buttonTypes } from "./IconButton.types.js";
import { css } from "@fluentui/utilities";
const IconButton$1 = "";
const defaultClassName = "ane-IconButton";
const getButtonType = (props) => {
  const { className, type = buttonTypes.default, text, children } = props;
  return !!text || !!children ? /* @__PURE__ */ jsx(DefaultButton, __spreadProps(__spreadValues({}, props), { className: css(className, defaultClassName, `ane-IconButton-${type}`) })) : /* @__PURE__ */ jsx(IconButton$2, __spreadProps(__spreadValues({}, props), { className: css(className, defaultClassName, `ane-IconButton-${type}`) }));
};
const IconButton = (props) => {
  const Button = getButtonType(props);
  return /* @__PURE__ */ jsx(WithCallout, { preventAutoTabIndex: true, calloutProps: props.calloutProps, children: Button });
};
export {
  IconButton,
  IconButton as default
};
//# sourceMappingURL=IconButton.js.map
